import React from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import OverviewPanel from '../BigPanel/OverviewPanel';
import ComponentPanel from '../BigPanel/ComponentPanel';
import SecurityPanel from '../BigPanel/SecurityPanel';
import LicensePanel from '../BigPanel/LicensePanel';
import PolicyPanel from '../BigPanel/PolicyPanel';
import PolicyRevisionPanel from '../BigPanel/PolicyRevisionPanel';
import OverviewDetailedPanel from '../BigPanel/OverviewDetailedPanel';
import ComponentDetailedPanel from '../BigPanel/ComponentDetailedPanel';
import SecurityDetailedPanel from '../BigPanel/SecurityDetailedPanel';
import LicenseDetailedPanel from '../BigPanel/LicenseDetailedPanel';
import PolicyDetailedPanel from '../BigPanel/PolicyDetailedPanel';
import MoveToTop from '../MoveTotop/MoveToTop';
import './SubLayout.css';

function Layout() {
  const location = useLocation();
  const path = location.pathname;
  const params = useParams();

  let activeTab;
  switch (true) {
  case path.indexOf('overview') !== -1 && path.indexOf(params.idReport) === -1:
    activeTab = <OverviewPanel />;
    break;
  case path.indexOf('overview') !== -1 && path.indexOf(params.idReport) !== -1:
    activeTab = <OverviewDetailedPanel />;
    break;
  case path.indexOf('component') !== -1 && path.indexOf(params.idReport) === -1:
    activeTab = <ComponentPanel />;
    break;
  case path.indexOf('component') !== -1 && path.indexOf(params.idReport) !== -1:
    activeTab = <ComponentDetailedPanel />;
    break;
  case path.indexOf('security') !== -1 && path.indexOf(params.idReport) === -1:
    activeTab = <SecurityPanel />;
    break;
  case path.indexOf('security') !== -1 && path.indexOf(params.idReport) !== -1:
    activeTab = <SecurityDetailedPanel />;
    break;
  case path.indexOf('license') !== -1 && path.indexOf(params.idReport) === -1:
    activeTab = <LicensePanel />;
    break;
  case path.indexOf('license') !== -1 && path.indexOf(params.idReport) !== -1:
    activeTab = <LicenseDetailedPanel />;
    break;
  case path.indexOf('policy') !== -1 && path.indexOf(params.idReport) === -1:
    activeTab = <PolicyPanel />;
    break;
  case path.indexOf('policy/binary') !== -1 && path.indexOf(params.idReport) !== -1:
    activeTab = <PolicyRevisionPanel />;
    break;
  case path.indexOf('policy/project') !== -1 && path.indexOf(params.idReport) !== -1:
    activeTab = <PolicyDetailedPanel />;
    break;
  default:
    activeTab = <OverviewPanel />;
    break;
  }

  return (
    <div>
      {activeTab}
      <div className="contents">
        <Outlet />
      </div>
      <MoveToTop />
    </div>
  );
}
export default Layout;
